import { React, _ } from 'Imports';
import { getEncompassAuthProvider } from 'oauth/authProviderFactory';
import { AuthProviderToken, IAuthProvider } from 'oauth/IAuthProvider';
import { withNavigate, WithNavigateProps } from '$Components/hocs/withNavigate';
import { StandardProtectedRoutePaths } from '../router/route-sets/standard-route-config';

const styles = require('oauth/Auth.scss') as {
  main: string;
  authMessage: string;
};

interface IAuthServiceState {
  user: AuthProviderToken | null;
  authProvider: IAuthProvider;
}

interface IAuthServiceProps {}

export class _AuthService extends React.Component<IAuthServiceProps & WithNavigateProps, IAuthServiceState> {

  constructor(props: any) {
    super(props);
    this.state = {
      user: null,
      authProvider: getEncompassAuthProvider(),
    };
  }

  async componentDidMount(): Promise<void> {
    const user = await this.getUser();
    if (user && user?.access_token) {
      this.props.history.push(StandardProtectedRoutePaths.VideoEvents);
    } else {
      await this.state.authProvider.login();
    }
  }

  private getUser(): Promise<AuthProviderToken | null> {
    return this.state.authProvider.getUser();
  }

  render() {
    return <></>;
  }
}

export const AuthService = withNavigate(_AuthService);